<template>
  <v-row justify="center">
    <v-dialog v-model="active" :persistent="fix" max-width="500">
      <v-card class="pa-3">
        <!-- <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon v-if="!fix" size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-img :src="images.warring" contain height="180" alt="系統公告"></v-img>
        <v-card-title class="text-h5 mb-1" style="font-weight:800">
          系統公告
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; min-height:110px; font-size:15px">
          為提供更好的考試報名與流程，系統已於 2023/6/15(四) 全面升級，若您無法登入系統，請重新註冊帳號與報名場次，造成您的不便敬請見諒。如有任何問題請聯繫學會 service@cerps.org.tw 或撥打電話 03-4264248 謝謝您 !
        </v-card-text>
        <v-row justify="center">
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#81C0E2"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row> -->
        <div class="pt-5 pb-3">
          <v-img :src="images.email" contain height="120" alt="信件"></v-img>
        </div>
        <v-card-text class="text-left mt-1 py-0" style="font-weight:600; min-height:110px; font-size:15px">
          <h4 v-html="dataHtml"></h4>
        </v-card-text>
        <v-row justify="center">
          <v-card-actions>
            <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#81C0E2"
            @click="save">
              確定
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'Warring',
    props:['onSave'],
    data () {
      return {
        active: false,
        fix: false,
        images:{
          warring: require('@/assets/image/warring.png'),
          email: require('@/assets/image/email.png'),
        },
        dataHtml: '<p>親愛的老師及考生 您好：</p><p>&nbsp; &nbsp; 本軟體系統將於 <span style="color:#e74c3c"><strong>2月4日（星期二）</strong></span>進行全日維護，當天 系統將無法使用，請您於<strong><span style="color:#e74c3c"> 2月5日（星期三）</span></strong>再行使用。<br />&nbsp; &nbsp;&nbsp;若有任何問題煩請致電至03-4264248<br />&nbsp; &nbsp; 或是E-MAIL聯繫service@cerps.org.tw<br />&nbsp; &nbsp; 造成您的不便敬請您見諒，謝謝</p><p>ERP學會 敬上</p>',
      }
    },
    methods:{
      open(fix = false,){
        this.active = true
        this.fix = fix
      },
      close(){
        this.active = false
      },
      save(){
        this.close()
      }
    }
  }
</script>